module.exports = __webpack_public_path__ + "img/pic_card2@2x.4f3cc0e8.png";